import { useDispatch, useSelector } from "react-redux";
import { GRADES, LOADING_GRADES } from "../store/selectors";
import { useEffect } from "react";
import { App } from "antd";
import {
  setLoading,
  setGrades,
  deleteGrade as deleteGradeAction,
} from "../store/slices/grade";
import {
  getGrades,
  getGradeById as getGradeByIdService,
  deleteGrade as deleteGradeService,
} from "../services/grade/grade.service";

export const useGrades = () => {
  // From App.useApp(): the static notification does not render under React 19.
  const { notification } = App.useApp();
  const dispatch = useDispatch();
  const grades = useSelector(GRADES);
  const loading = useSelector(LOADING_GRADES);

  const fetchInfo = async () => {
    dispatch(setLoading(true));
    try {
      if (grades?.length > 0) {
        setGrades(grades);
      } else {
        const gradesResponse = await getGrades();
        gradesResponse && dispatch(setGrades(gradesResponse));
      }
      dispatch(setLoading(false));
    } catch (error: any) {
      dispatch(setLoading(false));
      notification["error"]({
        message: "Error",
        description:
          "La información no pudo ser cargada, por favor notifica éste error!",
        placement: "top",
        duration: 3,
      });
      throw new Error(error);
    }
  };

  const getGradeById = async (id: number) => {
    try {
      const response = await getGradeByIdService(id);
      return response;
    } catch (error: any) {
      notification["error"]({
        message: "Error",
        description:
          "La información no pudo ser cargada, por favor notifica éste error!",
        placement: "top",
        duration: 3,
      });
      throw new Error(error);
    }
  };

  const deleteGrade = async (id: number): Promise<boolean> => {
    dispatch(setLoading(true));
    try {
      await deleteGradeService(id);
      dispatch(deleteGradeAction(id));
      notification["success"]({
        message: "Éxito",
        description: "El grado fue eliminado exitosamente!",
        placement: "top",
        duration: 3,
      });
      dispatch(setLoading(false));
      return true;
    } catch (error: any) {
      dispatch(setLoading(false));
      notification["error"]({
        message: "Eliminación Erronea",
        description:
          error?.response?.data?.message || "El grado no pudo ser eliminado!",
        placement: "top",
        duration: 3,
      });
      return false;
    }
  };

  useEffect(() => {
    fetchInfo();
  }, [setGrades, dispatch]);

  return {
    loading,
    grades,
    deleteGrade,
    getGradeById,
  };
};
